import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationService } from '../navigation/navigation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  footerContent;
  @ViewChild('footerContainer') footerContainer: ElementRef<HTMLDivElement>;
  constructor(private navigationService: NavigationService, private domSanitizer: DomSanitizer, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.getFooterContent();
  }

  getFooterContent() {
    this.navigationService.getFooterContent().subscribe((result: any) => {
      this.footerContent = this.domSanitizer.bypassSecurityTrustHtml(result?.contents[0]?.value?.section1);
    });
  }
}
